module.exports = __webpack_public_path__ + "a8a10a3e/img/copy-icon.408fdb2d.svg";